import { useEffect } from 'react';
import { Box, Button, Container, Divider, Stack, Typography } from '@mui/material';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import HomeIcon from '@mui/icons-material/Home';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { makeStyles } from 'tss-react/mui';
import { getLogger } from '@logging/logger';

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    gap: 2,
  },
  errorIconContainer: {
    borderRadius: '50%',
    width: 96,
    height: 96,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgb(254, 243, 199)',
  },
}));

export function ForbiddenError({ title, message, subMessage }: { title?: string; message?: string; subMessage?: string }) {
  const { classes } = useStyles();
  useEffect(() => {
    getLogger().warn('ForbiddenError page rendered', { route: window.location.pathname });
  }, []);
  return (
    <Container maxWidth='xl' className={classes.container}>
      <Stack
        spacing={4}
        direction={'column'}
        sx={{
          alignItems: 'center',
          marginBottom: 16,
        }}
      >
        <div className={classes.errorIconContainer}>
          <LockOutlinedIcon sx={{ fontSize: 44, color: '#d97706' }} />
        </div>
        <Typography variant='h1'>{title || 'Access Denied'}</Typography>
        <Typography variant='body1'>
          {message || "You don't have permission to view this page. Please contact your administrator if you believe this is a mistake."}
        </Typography>
        <Typography variant='body1'>{subMessage || 'If you think you should have access, reach out to your store administrator.'}</Typography>
        <Box>
          <Stack direction={'row'} spacing={2}>
            <Button variant='contained' size='large' color='primary' onClick={() => window.location.assign('https://www.squadlocker.com')}>
              <HomeIcon />
              &nbsp; SquadLocker Homepage
            </Button>
          </Stack>
        </Box>
        <Divider flexItem />
        <Typography variant='subtitle1'>Need help? We're here for you.</Typography>
        <Button variant='contained' color='secondary' onClick={() => window.location.assign('https://www.squadlocker.com/email-us')}>
          <ContactSupportIcon />
          &nbsp; Contact Support
        </Button>
      </Stack>
    </Container>
  );
}
